var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { Base64 } from "js-base64";
import { resolveImports } from "./import_parsing";
var extractExerciseArchive = function extractExerciseArchive(zip, configuration) {
  return __awaiter(void 0, void 0, void 0, function () {
    var t, rootFiles, srcFiles, testFiles, tmcFiles, problems, successful, fileSorter, pickedSrcFiles, testSource;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          t = configuration.t;
          return [4, getFileEntries(zip)];
        case 1:
          rootFiles = _a.sent();
          return [4, getFileEntries(zip, "src")];
        case 2:
          srcFiles = _a.sent();
          return [4, getFileEntries(zip, "test")];
        case 3:
          testFiles = _a.sent();
          return [4, getFileEntries(zip, "tmc")];
        case 4:
          tmcFiles = _a.sent();
          problems = [];
          successful = true;
          fileSorter = function fileSorter(files) {
            return files.sort(function (a, b) {
              return a.shortName.localeCompare(b.shortName);
            });
          };
          pickedSrcFiles = srcFiles.length > 0 ? fileSorter(srcFiles) : fileSorter(rootFiles);
          if (pickedSrcFiles.length === 0) {
            problems.push(t("noExerciseFilesFound"));
          }
          testSource = "";
          try {
            testSource = inlineAndPatchTestSources(testFiles, tmcFiles);
          } catch (e) {
            Array.isArray(e) ? problems.push.apply(problems, e) : problems.push(e);
            successful = false;
          }
          return [2, {
            problems: problems,
            srcFiles: pickedSrcFiles,
            successful: successful,
            testSource: testSource
          }];
      }
    });
  });
};
var getFileEntries = function getFileEntries(zip, directory, main) {
  var fileSelector = directory ? RegExp(directory + "/\\w*\\.py$") : /^\w+\/\w+\/\w*\.py$/;
  var files = orderFiles(zip.file(fileSelector), main);
  return Promise.all(files.map(function (f) {
    return createEntry(f);
  }));
};
var createEntry = function createEntry(f) {
  return __awaiter(void 0, void 0, void 0, function () {
    var content, fullName, matches, shortName;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4, f.async("string")];
        case 1:
          content = _a.sent();
          fullName = f.name;
          matches = fullName.match(/(\w+\.py)/);
          shortName = null;
          if (matches) {
            shortName = matches[0];
            return [2, {
              fullName: fullName,
              shortName: shortName,
              originalContent: content,
              content: content
            }];
          }
          return [2, {
            fullName: "",
            shortName: "",
            originalContent: "",
            content: ""
          }];
      }
    });
  });
};
var orderFiles = function orderFiles(files, main) {
  if (main) {
    var mainIndex = files.findIndex(function (file) {
      return file.name.includes(main);
    });
    if (mainIndex > -1) {
      var mainEntry = files.splice(mainIndex, 1)[0];
      files.unshift(mainEntry);
      return files;
    }
  }
  return files;
};
var stringifyPythonCode = function stringifyPythonCode(code) {
  var escaped = code.replace(/\\/g, "\\\\").replace(/"""/g, '\\"\\"\\"');
  return "\"\"\"\n" + escaped + "\n\"\"\"";
};
var createWebEditorModuleSource = function createWebEditorModuleSource(code) {
  return "\"\"\"\nimport base64\ncode = base64.b64decode(\"" + Base64.encode(code) + "\").decode(\"utf-8\")\n\"\"\"";
};
var inlineAndPatchTestSources = function inlineAndPatchTestSources(testFiles, tmcFiles) {
  var test = findMainTestFile(testFiles);
  var tmcHmacWriter = findFileByShortName("hmac_writer.py", tmcFiles, {
    content: "# old template",
    fullName: "",
    originalContent: "",
    shortName: "hmac_writer.py"
  });
  var tmcPoints = findFileByShortName("points.py", tmcFiles);
  var tmcResult = findFileByShortName("result.py", tmcFiles);
  var tmcRunner = findFileByShortName("runner.py", tmcFiles);
  var tmcUtils = findFileByShortName("utils.py", tmcFiles);
  var testCode = "\nimport base64, contextlib, importlib, io, json, sys\nfrom types import ModuleType\n\n_stdout_pointer = 0\n\ndef __wrap_import(module_name, code):\n    mod = ModuleType(module_name)\n    sys.modules[module_name] = mod\n    exec(code, mod.__dict__)\n\n__wrap_import(\"tmc_webeditor\", __webeditor_module_source)\n\n__wrap_import(\"tmc_hmac_writer\", " + stringifyPythonCode(patchTmcFile(tmcHmacWriter, tmcFiles)) + ")\n__wrap_import(\"tmc_points\", " + stringifyPythonCode(patchTmcFile(tmcPoints, tmcFiles)) + ")\n__wrap_import(\"tmc_result\", " + stringifyPythonCode(patchTmcFile(tmcResult, tmcFiles)) + ")\n__wrap_import(\"tmc_runner\", " + stringifyPythonCode(patchTmcFile(tmcRunner, tmcFiles)) + ")\n__wrap_import(\"tmc_utils\", " + stringifyPythonCode(patchTmcFile(tmcUtils, tmcFiles)) + ")\n\n" + patchTestSource(test, "PythonEditorTest", testFiles) + "\n\ntestOutput = \"\"\nfrom tmc_runner import TMCTestRunner\nfrom tmc_webeditor import code\n\nimport inspect\ndef getsource(module):\n    return code\ninspect.getsource = getsource\n\ntest_suite = unittest.TestLoader().loadTestsFromTestCase(PythonEditorTest)\nwith io.StringIO() as buf:\n    with contextlib.redirect_stdout(buf):\n        TMCTestRunner(stream=buf).run(test_suite)\n    from tmc_result import results\n    testOutput = json.dumps(results, ensure_ascii=False)\n    print(testOutput)\n";
  return testCode;
};
var findFileByShortName = function findFileByShortName(name, files, defaultFile) {
  var file = files.find(function (file) {
    return file.shortName === name;
  });
  if (!file) {
    if (defaultFile) {
      return defaultFile;
    }
    throw "Expected to find file \"" + name + "\"";
  }
  return file;
};
var findMainTestFile = function findMainTestFile(testFiles) {
  var testFile = testFiles.find(function (file) {
    return file.shortName !== "__init__.py";
  });
  if (!testFile) {
    throw "Couldn't find test file";
  }
  return testFile;
};
var patchTestSource = function patchTestSource(testFile, testClassName, testFiles) {
  var lines = testFile.content.split("\n");
  var patched = lines.map(function (line) {
    var importMatches = line.match(/^from tmc import ([\w,\s]+)/);
    if (importMatches) {
      return importMatches[1].split(",").map(function (pkg) {
        return "from tmc_" + pkg.trim() + " import " + pkg.trim();
      }).join("\n");
    }
    var importMatches2 = line.match(/from tmc\.(\w+) import ([\w,\s]+)/);
    if (importMatches2) {
      return "from tmc_" + importMatches2[1] + " import " + importMatches2[2];
    }
    return line.replace(/\w+Test\(unittest.TestCase\)/, testClassName + "(unittest.TestCase)");
  }).join("\n");
  return resolveImports(__assign(__assign({}, testFile), {
    content: patched
  }), testFiles);
};
var removeRelativeTmcImports = function removeRelativeTmcImports(source) {
  var lines = source.split("\n");
  return lines.map(function (line) {
    var match = line.match(/^import \.(\w+)/);
    if (match) {
      return "import tmc_" + match[1];
    }
    match = line.match(/^from \.(\w+) import ([\w,\s]+)/);
    if (match) {
      return "from tmc_" + match[1] + " import " + match[2];
    }
    match = line.match(/from tmc\.(\w+) import ([\w,\s]+)/);
    if (match) {
      return "from tmc_" + match[1] + " import " + match[2];
    }
    return line;
  }).join("\n");
};
var patchTmcFile = function patchTmcFile(file, tmcFiles) {
  var content = removeRelativeTmcImports(file.content);
  switch (file.shortName) {
    case "utils.py":
      content = patchTmcUtilsPy(content);
      break;
  }
  return resolveImports(__assign(__assign({}, file), {
    content: content
  }), tmcFiles);
};
var patchTmcUtilsPy = function patchTmcUtilsPy(source) {
  var stdOutPointerFound = false;
  var loadModuleFound = false;
  var reloadModuleFound = false;
  var defLoadModule = "    from types import ModuleType\n    from tmc_webeditor import code\n    mod = ModuleType(\"editorcontent\")\n    try:\n        exec(code, mod.__dict__)\n    except Exception as e:\n        return AssertionError(e)\n    return mod\n";
  var defReloadModule = "    global _stdout_pointer\n    if isinstance(module, AssertionError):\n        raise module\n    _stdout_pointer = len(sys.stdout.getvalue())\n    return load_module(\"editorcontent\")\n";
  var lines = ["import inspect", "def getsource(module):", "    return code", "inspect.getsource = getsource"].concat(source.split("\n"));
  var i = 0;
  while (i < lines.length) {
    var line = lines[i];
    if (line.startsWith("_stdout_pointer")) {
      stdOutPointerFound = true;
      i++;
    } else if (line.startsWith("def load_module")) {
      loadModuleFound = true;
      var blockEnd = findBlockEnd(lines, i);
      var newBlock = defLoadModule.split("\n");
      lines = replaceLines(lines, i + 1, blockEnd, newBlock);
      i += newBlock.length;
    } else if (line.startsWith("def reload_module")) {
      reloadModuleFound = true;
      var blockEnd = findBlockEnd(lines, i);
      var newBlock = defReloadModule.split("\n");
      lines = replaceLines(lines, i + 1, blockEnd, newBlock);
      i += newBlock.length;
    } else {
      i++;
    }
  }
  var missing = [];
  !stdOutPointerFound && missing.push("Expected to find global `_stdout_pointer` from tmc/utils.py.");
  !loadModuleFound && missing.push("Expected to find function `load_module` from tmc/utils.py.");
  !reloadModuleFound && missing.push("Expected to find function `reload_module` from tmc/utils.py.");
  if (missing.length > 0) {
    throw missing;
  }
  return lines.join("\n");
};
var replaceLines = function replaceLines(lines, from, to, replaceWith) {
  return lines.slice(0, from).concat(replaceWith).concat(lines.slice(to));
};
var findBlockEnd = function findBlockEnd(lines, at) {
  var startDepth = countIndentationDepth(lines[at]);
  var end = at + 1;
  while (end < lines.length && startDepth < countIndentationDepth(lines[end])) {
    end++;
  }
  return end;
};
var countIndentationDepth = function countIndentationDepth(line) {
  if (line.trim() === "") {
    return Number.MAX_SAFE_INTEGER;
  }
  return line.search(/\S/);
};
export { createWebEditorModuleSource, extractExerciseArchive };